import { useNavBarStore } from "../store";
import { AccountSelector } from "./accountSelector";
import { Box } from "@dealer-center/core-components";
export const Middle = () => {
  const { visibility } = useNavBarStore();
  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center"
      }}
    >
      {visibility.shouldShowAccountSelectorInCenter && (
        <AccountSelector iconOnly={visibility.shouldAccountSelectorBeAnIcon} />
      )}
    </Box>
  );
};
